import { useEffect, useState } from 'react';
import { api } from '../api/client';

const SAFE_DEFAULT = { code_execution: false, acp: false, workspace_configuration: false,
  self_setup: false, allowed_scopes: ['research_only', 'research_and_design'] };
let cached;
export function useCapabilities() {
  const [value, setValue] = useState(cached || SAFE_DEFAULT);
  useEffect(() => {
    let active = true;
    api.getCapabilities().then(result => {
      cached = result;
      if (active) setValue(result);
    }).catch(() => { /* Server policy remains authoritative while unavailable. */ });
    return () => { active = false; };
  }, []);
  return value;
}
